// Import model
import { CreatePaymentTermsRequest } from '../models/CreatePaymentTermsRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CreatePaymentTermsRequest - handles JSON serialization and deserialization with type validation
 */
export class CreatePaymentTermsRequestSerializer {
  /**
   * Deserializes a JSON string into a CreatePaymentTermsRequest instance
   */
  static deserialize(json: string): CreatePaymentTermsRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CreatePaymentTermsRequest instance
   */
  static fromObject(obj: any): CreatePaymentTermsRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CreatePaymentTermsRequest');
    }


    const instance: CreatePaymentTermsRequest = {
      discount: obj['discount'] as number | undefined,
      downPayment: obj['downPayment'] as number | undefined,
      downPaymentPercentage: obj['downPaymentPercentage'] as number | undefined,
      frequency: obj['frequency'] as string | undefined,
      installments: obj['installments'] as number | undefined,
      interestRatePercentage: obj['interestRatePercentage'] as number | undefined,
      isActive: obj['isActive'] as boolean | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CreatePaymentTermsRequest instances
   */
  static deserializeArray(json: string): CreatePaymentTermsRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CreatePaymentTermsRequest instance to a JSON string
   */
  static serialize(instance: CreatePaymentTermsRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CreatePaymentTermsRequest instance to a plain object
   */
  static toObject(instance: CreatePaymentTermsRequest): any {
    return {
      'discount': instance.discount,
      'downPayment': instance.downPayment,
      'downPaymentPercentage': instance.downPaymentPercentage,
      'frequency': instance.frequency,
      'installments': instance.installments,
      'interestRatePercentage': instance.interestRatePercentage,
      'isActive': instance.isActive,
    };
  }

  /**
   * Serializes an array of CreatePaymentTermsRequest instances to a JSON string
   */
  static serializeArray(instances: CreatePaymentTermsRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
